import { render, staticRenderFns } from "./VariantSifterDataTableView.vue?vue&type=template&id=199848be&scoped=true&"
import script from "./VariantSifterDataTableView.vue?vue&type=script&lang=js&"
export * from "./VariantSifterDataTableView.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterDataTableView.vue?vue&type=style&index=0&id=199848be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199848be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199848be')) {
      api.createRecord('199848be', component.options)
    } else {
      api.reload('199848be', component.options)
    }
    module.hot.accept("./VariantSifterDataTableView.vue?vue&type=template&id=199848be&scoped=true&", function () {
      api.rerender('199848be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterDataTableView.vue"
export default component.exports